/* eslint-disable react/no-multi-comp */
import React from 'react';
import AbstractDriver from './abstractDriver';

export default class Portmone extends AbstractDriver {
  componentDidMount() {
    if (!this.form) {
      return console.error('Form reference for pay driver "portmone" not set');//eslint-disable-line
    }
    this.form.submit();
    this.props.payRequestSent();
  }

  render() {
    const { waybackUrl, order, config, description } = this.props;
    return (
      <form
        action="https://www.portmone.com.ua/gateway/"
        method="post"
        ref={el => this.form = el}
      >DriverRunner
        <input
          type="hidden"
          name="bodyRequest"
          value={JSON.stringify({
            paymentTypes: config.paymentTypes,
            payee: {
              payeeId: config.payeeId
            },
            order: {
              shopOrderNumber: `${order.project}-${order.id}`,
              billAmount: order.amount,
              successUrl: waybackUrl,
              failureUrl: waybackUrl,
              description
            }
          })} />
        <input type="hidden" name="typeRequest" value="json" />
      </form>
    );
  }
}

